var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("second-nav-bar"),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "table-container scroll" }, [
          _c("span", { staticClass: "role-manage-span" }, [_vm._v("角色管理")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "role-container" },
            _vm._l(_vm.roles, function(item) {
              return _c(
                "el-button",
                {
                  key: item.middle,
                  class: _vm.activeRole === item.middle ? "actived" : "",
                  attrs: { type: "primary", size: "medium", plain: "" },
                  on: {
                    click: function($event) {
                      return _vm.clickRole(item)
                    }
                  }
                },
                [_vm._v(_vm._s(item.left))]
              )
            }),
            1
          ),
          _vm._v(" "),
          _vm.roleG1
            ? _c("div", { staticClass: "add-person" }, [
                _c("span", { staticStyle: { "font-weight": "500" } }, [
                  _c("span", { staticStyle: { color: "var(--theme-color)" } }, [
                    _vm._v(_vm._s(_vm.roleName))
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: { "padding-left": "5px", color: "#444444" }
                    },
                    [_vm._v("成员列表")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { "margin-top": "20px", "line-height": "50px" }
                  },
                  [
                    _vm._l(_vm.persons, function(person) {
                      return _c(
                        "el-tag",
                        {
                          key: person.value,
                          staticStyle: { "margin-right": "20px" },
                          attrs: { type: "info", closable: "" },
                          on: {
                            close: function($event) {
                              return _vm.deletePerson(person)
                            }
                          }
                        },
                        [_vm._v(_vm._s(person.name))]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "medium", plain: "" },
                        on: { click: _vm.addPerson }
                      },
                      [_vm._v("+ 添加")]
                    )
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "permisson-set" },
            [
              _c("span", { staticStyle: { "font-weight": "500" } }, [
                _c("span", { staticStyle: { color: "var(--theme-color)" } }, [
                  _vm._v(_vm._s(_vm.roleName))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticStyle: { "padding-left": "5px", color: "#444444" } },
                  [_vm._v("权限配置")]
                )
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: {
                    data: _vm.permissionData,
                    size: "medium",
                    border: "",
                    "header-cell-style": { background: "#f9f9f9" }
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "功能模块", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-checkbox-group",
                              {
                                on: {
                                  change: function(val) {
                                    _vm.changeModule(val, scope.row)
                                  }
                                },
                                model: {
                                  value: scope.row.checkedModule,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "checkedModule", $$v)
                                  },
                                  expression: "scope.row.checkedModule"
                                }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      label: scope.row.t1.id,
                                      disabled: scope.row.t1.disabled
                                    }
                                  },
                                  [_vm._v(_vm._s(scope.row.t1.name))]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "功能要点" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-checkbox-group",
                              {
                                on: {
                                  change: function(val) {
                                    _vm.changePoint(val, scope.row)
                                  }
                                },
                                model: {
                                  value: scope.row.checkedPermission,
                                  callback: function($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "checkedPermission",
                                      $$v
                                    )
                                  },
                                  expression: "scope.row.checkedPermission"
                                }
                              },
                              [
                                _vm._l(scope.row.t2, function(item) {
                                  return [
                                    _c(
                                      "el-checkbox",
                                      {
                                        key: item.id,
                                        attrs: {
                                          label: item.id,
                                          disabled: item.disabled
                                        }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  ]
                                })
                              ],
                              2
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.saveConfig }
                },
                [_vm._v("保存配置")]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("add-permission-person", {
        attrs: { visible: _vm.editorVisible, identify: _vm.roleInfo },
        on: {
          "update:visible": function($event) {
            _vm.editorVisible = $event
          },
          "edit-result": function($event) {
            return _vm.initMembers(_vm.activeRole)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v("权限配置 / 权限管理")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-153ba6c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-153ba6c5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/district-admin/permission/PermissionManage.vue
// module id = null
// module chunks = 